<template>
  <div class="home">
    <div class="home__barra">
      <div class="home__grupo">
        <strong class="home__titulo">🏠 HOME</strong>
        <span class="home__separador"></span>
        <label class="home__campo">
          <span>Gestor:</span>
          <select :value="gestor === null ? '' : gestor" @change="$emit('update:gestor', $event.target.value ? Number($event.target.value) : null)">
            <option value="">Todos</option>
            <option v-for="g in gestores" :key="g.id" :value="g.id">{{ g.nombre }}</option>
          </select>
        </label>
        <span class="home__separador"></span>
        <div class="home__modos">
          <button type="button" :class="{ 'home__modo--activo': modo === 'todos' }" @click="modo = 'todos'">
            Todos ({{ filtradas.length }})
          </button>
          <button type="button" :class="{ 'home__modo--acciones': modo === 'acciones' }" @click="modo = 'acciones'">
            ⚡ Solo Acciones <span class="home__cuenta">{{ pendientes('accion') }}</span>
          </button>
          <button type="button" :class="{ 'home__modo--docs': modo === 'documentos' }" @click="modo = 'documentos'">
            📁 Solo Docs/Hitos <span class="home__cuenta">{{ pendientes('documento') }}</span>
          </button>
        </div>
        <button class="home__chico" type="button" @click="expandirTodas(true)">Expandir todas</button>
        <button class="home__chico" type="button" @click="expandirTodas(false)">Contraer todas</button>
      </div>

      <div class="home__grupo">
        <span class="home__metrica">Terrenos: <strong>{{ delGestor.length }}</strong></span>
        <button
          type="button"
          class="home__metrica home__metrica--critica"
          :class="{ 'home__metrica--activa': nivel === 'critica' }"
          @click="nivel = nivel === 'critica' ? null : 'critica'"
        >🔴 Críticas: <strong>{{ contar('critica') }}</strong></button>
        <button
          type="button"
          class="home__metrica home__metrica--alta"
          :class="{ 'home__metrica--activa': nivel === 'alta' }"
          @click="nivel = nivel === 'alta' ? null : 'alta'"
        >🟠 Altas: <strong>{{ contar('alta') }}</strong></button>
        <label class="home__campo home__campo--borde">
          <span>Etapa:</span>
          <select v-model="etapa">
            <option :value="null">Todas</option>
            <option v-for="f in fasesEnFlujo" :key="f.id" :value="f.id">{{ etiqueta(f) }}</option>
          </select>
        </label>
        <button v-if="hayFiltros" class="home__enlace" type="button" @click="restablecer">Restablecer</button>
      </div>
    </div>

    <div v-if="!filtradas.length" class="home__vacio">
      <h3>No hay terrenos asignados con los filtros seleccionados</h3>
      <p>Puedes cambiar el gestor o restablecer los filtros de urgencia y etapa.</p>
      <button class="negocio__boton" type="button" @click="restablecer(); $emit('update:gestor', null)">Ver todos los terrenos</button>
    </div>

    <article
      v-for="u in filtradas"
      :key="u.id"
      class="home__unidad"
      :class="{ 'home__unidad--alerta': u.alertas_activas }"
    >
      <header class="home__cabecera" @click="alternar(u.id)">
        <div class="home__grupo">
          <strong class="home__terreno">{{ u.terreno.nombre }}</strong>
          <span class="home__tenue">({{ u.terreno.comuna || '—' }})</span>
          <span class="home__punto">·</span>
          <span class="home__cliente">{{ u.cliente }}</span>
          <span v-if="u.cliente_tipo" class="home__tenue">({{ u.cliente_tipo }})</span>
          <span class="home__punto">·</span>
          <span class="home__etapa">{{ etiquetaEtapa(u.fase) }}</span>
          <span class="home__hito" :class="`negocio__caluga--${u.semaforo || 'sin-hito'}`">🎯 {{ nombreSemaforo(u.semaforo) }}</span>
          <span v-if="u.alertas_activas" class="home__alerta">🚨 ALERTA CRÍTICA ({{ u.alertas_activas }})</span>
        </div>

        <div class="home__grupo">
          <span class="home__urgencia" :class="`home__urgencia--${claseUrgencia(u.urgencia)}`">{{ textoUrgencia(u.urgencia) }}</span>
          <span class="home__tenue" :title="u.ultima ? u.ultima.tipo : 'Entrada a la etapa'">
            🕒 Último mov: <strong>{{ fecha(u.ultimo_movimiento) }}</strong>
          </span>
          <span class="home__avance">
            <strong :class="{ 'home__ok': u.completa }">{{ u.avance }}%</strong>
            <span class="home__barrita"><span :class="{ 'home__barrita--ok': u.completa }" :style="{ width: `${u.avance}%` }"></span></span>
          </span>
          <button class="home__boton home__boton--blanco" type="button" @click.stop="$emit('ficha', u.id)">Ficha Caluga</button>
          <button
            v-if="u.completa && u.siguiente_fase"
            class="home__boton home__boton--verde"
            type="button"
            :disabled="ocupado"
            @click.stop="hacer(() => negocioAvanzar(u.id))"
          >🚀 Avanzar Etapa</button>
          <button
            class="home__boton"
            :class="abiertas.has(u.id) ? 'home__boton--abierto' : 'home__boton--blanco'"
            type="button"
            @click.stop="alternar(u.id)"
          >
            {{ abiertas.has(u.id) ? '▲ Ocultar' : '▼ Ver tareas y docs' }}
            <span class="home__cuenta" :class="pendientesDe(u) ? 'home__cuenta--ambar' : 'home__cuenta--ok'">{{ pendientesDe(u) }}</span>
          </button>
        </div>
      </header>

      <div v-if="abiertas.has(u.id)" class="home__cuerpo">
        <div class="home__tabla-caja">
          <div class="home__tabla-titulo">
            <span>
              {{ u.alertas_activas ? '🚨 Alertas Activas, Tareas y Documentos' : '📋 Acciones Operativas, Documentos e Hitos' }}
              ({{ filas(u).filter((i) => i.listo).length }}/{{ filas(u).length }})
            </span>
            <small>
              {{ u.alertas_activas ? `⚠️ ${u.alertas_activas} alerta(s) prioritaria(s) pendiente(s)` : (pendientesDe(u) ? `Faltan ${pendientesDe(u)} pendientes` : '✓ Todos completados') }}
            </small>
          </div>
          <table class="home__tabla">
            <thead>
              <tr><th>Nombre</th><th>Tipo</th><th>Plazo</th><th class="negocio__centro">Estado</th><th class="negocio__centro">Acción</th><th class="negocio__centro">Cambiar Plazo</th></tr>
            </thead>
            <tbody>
              <tr v-if="!filas(u).length">
                <td colspan="6" class="negocio__centro">
                  <span class="home__info">ℹ️ Esta etapa no exige acciones ni documentos.</span>
                </td>
              </tr>
              <tr v-for="i in filas(u)" :key="`${i.tipo}-${i.id}`" :class="{ 'home__fila--lista': i.listo, 'home__fila--alerta': i.tipo === 'alerta' && !i.listo }">
                <td>
                  <div class="home__nombre">{{ i.nombre }}</div>
                  <small v-if="i.detalle">{{ i.detalle }}</small>
                </td>
                <td><span class="home__tipo" :class="`home__tipo--${i.tipo}`">{{ TIPOS[i.tipo] }}</span></td>
                <td class="home__plazo">
                  <strong v-if="i.tipo === 'alerta'" class="negocio__tarde">⚡ Inmediato / Hoy</strong>
                  <template v-else-if="i.prorroga">
                    <strong class="home__azul">Plazo: {{ i.plazo_dias }}d</strong>
                    <span class="home__prorrogado" :title="`Razón: ${i.prorroga}`">Prorrogado</span>
                    <small :title="`Razón: ${i.prorroga}`">📅 {{ fecha(i.vence) }}</small>
                  </template>
                  <template v-else>
                    Plazo: {{ i.plazo_dias }}d
                    <strong v-if="i.atraso && !i.listo" class="negocio__tarde">(+{{ i.atraso }}d)</strong>
                  </template>
                </td>
                <td class="negocio__centro">
                  <span v-if="i.listo" class="negocio__badge negocio__badge--ok">✓ Listo</span>
                  <span v-else-if="i.tipo === 'alerta'" class="home__urgente">Urgente</span>
                  <span v-else-if="i.vencido" class="negocio__badge negocio__badge--rojo">Atrasado</span>
                  <span v-else-if="i.vence_hoy" class="negocio__badge negocio__badge--ambar">Vence hoy</span>
                  <span v-else-if="i.prorroga" class="negocio__badge home__badge-azul" :title="`Razón: ${i.prorroga}`">Prorrogado</span>
                  <span v-else class="negocio__badge negocio__badge--ambar">Pendiente</span>
                </td>
                <td class="negocio__centro">
                  <span v-if="i.listo" class="home__tenue">—</span>
                  <label v-else-if="i.tipo === 'documento'" class="home__boton home__boton--docs">
                    {{ i.boton }}
                    <input type="file" :disabled="ocupado" @change="subir(u, i, $event)">
                  </label>
                  <button
                    v-else
                    class="home__boton"
                    :class="i.tipo === 'alerta' ? 'home__boton--rojo' : 'home__boton--azul'"
                    type="button"
                    :disabled="ocupado"
                    @click="cumplir(u, i)"
                  >{{ i.boton }}</button>
                </td>
                <td class="negocio__centro">
                  <button
                    v-if="i.tipo !== 'alerta' && !i.listo"
                    class="home__boton home__boton--gris"
                    type="button"
                    @click="$emit('plazo', { unidad: u.id, item: { [i.tipo]: i.id }, nombre: i.nombre, actual: i.vence })"
                  >⏱️ Cambiar Plazo</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import {
  mensajeError, negocioAvanzar, negocioCumplirAccion, negocioResolverAlerta, negocioSubirDocumento,
} from '../../services/comandoApi';

const FECHA = new Intl.DateTimeFormat('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric' });
const TIPOS = { alerta: '🚨 Alerta', accion: '⚡ Acción Operativa', documento: '📁 Documento e Hito' };

// El HOME del gestor: las unidades de la categoría con lo que les falta en su etapa.
// Las acciones llaman a la API y avisan con `cambio` para que el tablero recargue.
export default {
  name: 'HomeGestor',

  props: {
    unidades: { type: Array, required: true },
    fases: { type: Array, required: true },
    semaforos: { type: Array, required: true },
    gestor: { type: Number, default: null },
    semaforo: { type: String, default: undefined },
  },

  emits: ['update:gestor', 'ficha', 'enviar', 'plazo', 'cambio', 'error'],

  data() {
    return {
      TIPOS,
      modo: 'todos',
      nivel: null,
      etapa: null,
      abiertas: new Set(),
      ocupado: false,
    };
  },

  computed: {
    gestores() {
      const vistos = new Map();
      this.unidades.forEach((u) => { if (u.gestor) vistos.set(u.gestor.id, u.gestor); });
      return [...vistos.values()].sort((a, b) => a.nombre.localeCompare(b.nombre));
    },
    fasesEnFlujo() {
      return this.fases.filter((f) => !f.fuera_de_flujo);
    },
    // Las métricas cuentan sobre el gestor elegido, antes de los filtros de urgencia y etapa.
    delGestor() {
      return this.unidades.filter((u) => (
        (this.gestor === null || (u.gestor && u.gestor.id === this.gestor))
        && (this.semaforo === undefined || u.semaforo === this.semaforo)
      ));
    },
    filtradas() {
      return this.delGestor.filter((u) => (
        (this.nivel === null || u.urgencia.nivel === this.nivel)
        && (this.etapa === null || u.fase.id === this.etapa)
      ));
    },
    hayFiltros() {
      return this.nivel !== null || this.etapa !== null || this.modo !== 'todos';
    },
  },

  methods: {
    negocioAvanzar,

    // Las alertas se ven siempre; el modo sólo filtra acciones y documentos.
    filas(u) {
      const filas = u.items.filter((i) => (
        i.tipo === 'alerta'
        || this.modo === 'todos'
        || (this.modo === 'acciones' && i.tipo === 'accion')
        || (this.modo === 'documentos' && i.tipo === 'documento')
      ));
      const peso = (i) => (i.listo ? 2 : (i.tipo === 'alerta' ? 0 : 1));
      return filas.slice().sort((a, b) => peso(a) - peso(b));
    },

    pendientesDe(u) {
      return this.filas(u).filter((i) => !i.listo).length;
    },

    pendientes(tipo) {
      return this.delGestor.reduce((n, u) => n + u.items.filter((i) => i.tipo === tipo && !i.listo).length, 0);
    },

    contar(nivel) {
      return this.delGestor.filter((u) => u.urgencia.nivel === nivel).length;
    },

    restablecer() {
      this.nivel = null;
      this.etapa = null;
      this.modo = 'todos';
    },

    alternar(id) {
      const abiertas = new Set(this.abiertas);
      if (abiertas.has(id)) abiertas.delete(id);
      else abiertas.add(id);
      this.abiertas = abiertas;
    },

    expandirTodas(abrir) {
      this.abiertas = abrir ? new Set(this.filtradas.map((u) => u.id)) : new Set();
    },

    async hacer(operacion) {
      this.ocupado = true;
      try {
        await operacion();
        this.$emit('cambio');
      } catch (e) {
        this.$emit('error', mensajeError(e));
      } finally {
        this.ocupado = false;
      }
    },

    // Despachar la INFO 1 se hace mandando el correo: lo abre el tablero.
    cumplir(u, item) {
      if (item.tipo === 'alerta') this.hacer(() => negocioResolverAlerta(u.id, item.id));
      else if (item.evento === 'info1_enviada') this.$emit('enviar', u.id);
      else this.hacer(() => negocioCumplirAccion(u.id, item.id));
    },

    subir(u, item, evento) {
      const archivo = evento.target.files[0];
      evento.target.value = '';
      if (archivo) this.hacer(() => negocioSubirDocumento(u.id, item.id, archivo));
    },

    etiqueta(f) {
      const nombre = f.nombre;
      return f.numero ? `${f.numero}: ${nombre}` : nombre;
    },

    etiquetaEtapa(f) {
      return f.numero ? `Etapa ${f.numero}: ${f.nombre}` : f.nombre;
    },

    nombreSemaforo(id) {
      const s = this.semaforos.find((x) => x.id === id);
      return s ? s.nombre : 'Sin hitos';
    },

    claseUrgencia(urg) {
      if (urg.prorrogado && (urg.nivel === 'media' || urg.nivel === 'normal')) return 'prorrogada';
      return urg.nivel;
    },

    textoUrgencia(urg) {
      if (urg.nivel === 'critica') return `🔴 Crítica (${urg.dias}d)`;
      if (urg.nivel === 'alta') return `🟠 Alta (${urg.dias}d)`;
      if (urg.prorrogado) return `⏱️ Plazo Prorrogado (${urg.dias}d / ${urg.sla}d)`;
      if (urg.nivel === 'media') return `🟡 Media (${urg.dias}d)`;
      return `🟢 Normal (${urg.dias}d)`;
    },

    fecha(valor) {
      return valor ? FECHA.format(new Date(valor)) : '—';
    },
  },
};
</script>
